import { useMemo, useRef } from "react";

export const useDefault = <T>(
  value: T | undefined | null,
  defaultValue: T
): T => {
  const defaultRef = useRef(defaultValue);
  return useMemo(() => value ?? defaultRef.current, [value]);
};
